/**
 * !!! AUTOGENERATED, DO NOT MODIFY !!!
 *
 * This file is generated by dashboard/script/remote_lookup/generate_remote_lookup_schemas.rb
 * Because the generation script depends on rails, generation is run manually and the file is checked in.
 * Please do not edit manually.
 *
 * To regenerate, run:
 *   yarn remote-lookup:update-generated-schemas
 *
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../common";

// Our zod-to-typescript generation tooling demands an export that matches the module name.
export const appRemoteLookupSchema = z.any();

export const appRemoteLookupIdSchema = common.objectId;

export const appRemoteLookupItemSchema = z.object({
  id: common.objectId,
  name: z.string(),
  platform: z
    .enum([
      "android",
      "android_china",
      "ios",
      "kepler",
      "kindle",
      "landing_page",
      "roku",
      "tvos",
      "web",
      "windows8",
    ])
    .nullable(),
  is_archived: z.boolean(),
});

export const appRemoteLookupFiltersSchema = z.object({
  platform_types: z
    .array(
      z.enum([
        "android",
        "android_china",
        "ios",
        "kepler",
        "kindle",
        "landing_page",
        "roku",
        "tvos",
        "web",
        "windows8",
      ])
    )
    .nullable()
    .nullable()
    .optional(),
});

export const appRemoteLookupValidators = {
  id: appRemoteLookupIdSchema,
  item: appRemoteLookupItemSchema,
  filters: appRemoteLookupFiltersSchema,
};

/* rails_test_output_hash: 18698d7456430b64cbfff02d2540ea87 */
